import request, { getUserToken, v2Request } from "utils/request";
import { baseRequestURL } from "api/BaseAPI";

export const NOT_ACTIVATED = "NOT_ACTIVATED";

export function getAccounts() {
  return request(baseRequestURL + "v1/accounts", {
    method: "GET"
  }).then((response) => response);
}

export function activateAzureUser(fullname, username, company, token) {
  // const pageURL = window.location.protocol + "//" + window.location.host;
  // const successURL = pageURL + "/login/azure";
  // const failureURL = pageURL + "/registration?token=" + token + "&error=" + encodeURIComponent("Something went wrong! Please try again or contact us for help.")
  return request(
    // baseRequestURL + "v1/azure/provision?on_success=" + encodeURIComponent(successURL) + "&on_failure=" + encodeURIComponent(failureURL),
    baseRequestURL + "v1/azure/provision",
    {
      method: "POST",
      body: JSON.stringify({
        root_fullname: fullname,
        root_user_email: username,
        tenant_name: company,
        token: token
      })
    },
    true
  );
}

export function registerUser(fullname, username, password, inviteToken, uiState) {
  let queryParams = "";
  if (uiState) {
    queryParams = "?ui-state=" + uiState;
  }
  return request(
    baseRequestURL + "v1/login/create" + queryParams,
    {
      method: "POST",
      body: JSON.stringify({
        fullname: fullname,
        email: username,
        password: password,
        accepts_terms_of_service: true,
        invite_tokens: inviteToken
      })
    },
    true
  ).then((response) => response);
}

export function registerUsersBulk(csvBody, accessKey) {
  const headers = new Headers();
  headers.set("Authorization", "Bearer " + accessKey);
  headers.set("Content-Type", "text/csv");

  return request(
    baseRequestURL + "v1/login/create_bulk",
    {
      method: "POST",
      headers: headers,
      body: csvBody
    },
    true
  ).then((response) => response);
}

export function registerTenant(fullname, accessKey) {
  return request(
    baseRequestURL + "v1/tenants",
    {
      method: "POST",
      body: JSON.stringify({
        fullname: fullname
      }),
      headers: { Authorization: "Bearer " + accessKey }
    },
    true
  ).then((response) => response);
}

export function postUser(user) {
  return request(
    baseRequestURL + "v1/login/",
    {
      method: "POST",
      body: JSON.stringify({
        email: user
      })
    },
    true
  ).then((response) => response);
}

export function postPassword(token, password) {
  return request(
    baseRequestURL + "v1/login/password",
    {
      method: "POST",
      body: JSON.stringify({
        password: password,
        token: token
      })
    },
    true
  ).then((response) => response);
}

export function resetPassword(token) {
  return request(
    baseRequestURL + "v1/login/reset",
    {
      method: "POST",
      body: JSON.stringify({
        token: token
      })
    },
    true
  ).then((response) => response);
}

export function updateUserPassword(passwordObj, userAuth, email = undefined) {
  const searchParams = new URLSearchParams("");
  let retQuery = `${baseRequestURL}v1/me`;

  if (email) {
    searchParams.append("superuser::override-email", email.toString());
    retQuery = retQuery + `?${searchParams.toString()}`;
  }

  return request(retQuery, {
    method: "PATCH",
    headers: { Authorization: "Bearer " + userAuth },
    body: JSON.stringify(passwordObj)
  }).then((response) => response);
}

// MB: Only refreshes the currently selected tenant by inferring the current aible_auth_token through request
export function refreshToken(noLogout = false, isLogoutCheck = true) {
  return request(
    baseRequestURL + "v1/renew/tenant",
    {
      method: "POST"
    },
    false,
    noLogout,
    undefined,
    undefined,
    isLogoutCheck
  ).then((response) => response);
}

/** Renew a specific tenant by it's token.
 *
 * @param {string} tenantToken
 * @param {import("utils/request").OptionsV2} requestOptions
 * @returns {Promise<Tenant>}
 */
export function refreshTenantToken(tenantToken, requestOptions = {}) {
  return v2Request(
    baseRequestURL + "v1/renew/tenant",
    {
      ...requestOptions,
      disableAuth: true,
      options: {
        method: "POST",
        headers: {
          Authorization: `Bearer ${tenantToken}`
        }
      },
    }
  )
}

export function refreshUserToken(token) {
  if (!token) {
    token = getUserToken();
  }
  return request(
    baseRequestURL + "v1/renew/login",
    {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token
      }
    },
    true
  ).then((response) => response);
}

export function getAppConfig() {
  return request(baseRequestURL + "v1/config", {
    method: "GET"
  }).then((response) => response);
}

export function getAPIBaseURL() {
  return baseRequestURL;
}
